import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["provider", "model"]
  static values = {
    models: { type: Object, default: {} },
    currentModel: { type: String, default: "" },
  }

  connect() {
    this.updateModels()
  }

  updateModels() {
    const models = this.modelsValue[this.providerTarget.value] || []
    const current = this.currentModelValue

    this.modelTarget.innerHTML =
      models.length === 0
        ? '<option value="">Select a provider first</option>'
        : models
            .map(
              (m) => `<option value="${m}"${m === current ? " selected" : ""}>${m}</option>`,
            )
            .join("")
  }
}
